import { z } from "zod";

export const applicantSchema = z.object({
  name: z.string().min(3, "Ingrese un nombre válido"),
  email: z
    .union([z.literal(""), z.string().email("Ingrese un correo válido")])
    .optional(),
  phone: z.string().optional(),
  companyId: z.string().min(3, "Seleccione una empresa"),
  zoneId: z.string().min(3, "Seleccione una zona"),
  enabled: z.boolean().default(true),
});
